// Route paths for the AI Agent Navigator screens (IA v0.1 GNB).
// Draft: final paths are fixed when each GNB screen is built.
import { AI_ASSISTANT_ENABLED } from "@/lib/feature-flags";

export const NV_PATHS = {
  home: "/",
  agentFinder: "/agent-finder",
  caseStudy: "/case-study",
  aiAssistant: AI_ASSISTANT_ENABLED ? "/chat" : "/ai-assistant",
  agentRegister: "/agent-register",
  productManage: "/product-manage",
  contact: "/contact",
  login: "/login",
  signup: "/signup",
  myPage: "/my-page",
  terms: "/terms",
  privacy: "/privacy",
} as const;

// 로그인 화면 주소. 로그인 뒤 돌아갈 화면(쿼리 포함)을 ?redirect= 로 넘겨요 — 이 형식은 여기 한 곳만 써요.
export const nvLoginPath = (returnTo?: string) =>
  returnTo
    ? `${NV_PATHS.login}?redirect=${encodeURIComponent(returnTo)}`
    : NV_PATHS.login;

// 에이전트 상세 (F01-1) — 외부 · 내부 상세 모두 같은 경로, 화면이 detail_type으로 갈라요
export const nvAgentDetailPath = (agentId: string) => `/agents/${agentId}`;
export const nvCaseStudyPath = (caseId: string) =>
  `${NV_PATHS.caseStudy}/${caseId}`;
